export default {
  sb: {
    "take-away": "Batal",
    "please-input": "Sila masukkan",
    "please-select": "Sila pilih",
    "pack-up-screen": "Kemaskan penapis",
    "more-screening": "Lebih banyak penapis",
    sure: "OK",
    reset: "Tetapkan semula",
    query: "Pertanyaan",
    to: "Ke",
    "start-date": "Tarikh mula",
    "end-date": "Tarikh tamat",
    "start-time": "Masa Mula",
    "end-time": "Masa Tamat",
    "please-enter-the-content": "Sila masukkan kandungan",
    "upload-video": "Muat naik video",
    "please-upload-video-file": "Sila muat naik video",
    "only-support-pm4": "Hanya fail video dalam format MP4 boleh dimuat naik",
    "select-all": "Pemilihan halaman ",
    "selected-n-item": "{num} item dipilih"
  }
};
